import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Col } from 'reactstrap'
import { Btn, H1, Image, P } from '../../../../AbstractElements'
import { dynamicImage, dynamicNumber } from '../../../../Utils'
import { Href } from '../../../../Utils/Constants'
import DashboardSvgIcon from '../../../../Utils/CommonComponents/DashboardSvgIcon'

export default function WelcomeBanner() {
    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }));

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }));
        }, 1000); // update every second

        return () => clearInterval(interval); // cleanup on unmount
    }, []);
    return (
        <Col className="proorder-xxl-1 box-col-6 mb-4">
            <Card className="welcome-banner">
                <CardHeader className="p-0 card-no-border">
                    <div className="welcome-card">
                        <Image className="w-100 img-fluid" src={dynamicImage(`dashboard-1/welcome-bg.png`)} alt="" />
                        {dynamicNumber(5).map((item, index) => (
                            <Image key={index} className={`position-absolute img-${item} img-fluid`} src={dynamicImage(`dashboard-1/img-${item}.png`)} alt="" />
                        ))}
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="d-flex align-center">
                        <H1>{'Hello, Admin '}
                            <Image src={dynamicImage(`dashboard-1/hand.png`)} alt="" />
                        </H1>
                    </div>
                    <P> {'Welcome back! Let’s start from where you left. Monitor your fleet status, track expenses, and manage maintenance schedules to ensure optimal performance and cost efficiency across all branches.'}</P>
                    <div className="d-flex align-center justify-content-between">
                        <span>
                            <DashboardSvgIcon className='stroke-icon' iconId='watch' />
                            {' ' + currentTime}
                        </span>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}